import { EventBus } from '@fiverr-private/futile/lib/event/EventBus';

export const commentEventsBus = new EventBus();
export const COMMENT_CLICK_EVENT = 'comment:clicked';
export const COMMENT_ADDED_EVENT = 'comment:added';
export const REPLY_CLICKED = 'reply:clicked';
